export default "__VITE_ASSET__B0Q8en4d__"